import {createPath} from 'react-router-dom';
import type {Path} from 'react-router-dom';

export const authRedirectParam = 'next';

export function getAuthRedirectFromSearch(search: string): string | null {
  const redirectUri = new URLSearchParams(search).get(authRedirectParam);
  return isSafeAuthRedirectUri(redirectUri) ? redirectUri : null;
}

export function getAuthPagePathWithRedirect(
  authPagePath: string,
  location: Partial<Path>,
): string {
  return getAuthPagePathWithRedirectUri(authPagePath, createPath(location));
}

export function getAuthPagePathWithRedirectUri(
  authPagePath: string,
  redirectUri: string,
): string {
  const params = new URLSearchParams();
  params.set(authRedirectParam, redirectUri);
  return `${authPagePath}?${params}`;
}

export function getAuthPagePathPreservingRedirect(
  authPagePath: string,
  location: Partial<Path>,
): string {
  const redirectUri =
    getAuthRedirectFromSearch(location.search ?? '') ?? createPath(location);
  const params = new URLSearchParams();
  params.set(authRedirectParam, redirectUri);
  return `${authPagePath}?${params}`;
}

function isSafeAuthRedirectUri(
  redirectUri: string | null,
): redirectUri is string {
  return (
    !!redirectUri && redirectUri.startsWith('/') && !redirectUri.startsWith('//')
  );
}
